module.exports = __webpack_public_path__ + "static/assets/fa945ee6723e936790970b40e6d3fe1f.svg";